// extracted by mini-css-extract-plugin
module.exports = {"container":"AddFrameView_container__h65eH","overlay":"AddFrameView_overlay__2uYSH"};